import { types } from '../types/types';

// Sidebar set state
export const setShowSideBar = (data) => ({
	type: types.setShowSideBar,
	payload: data,
});

// Sidebar reset state
export const resetSideBar = () => ({
	type: types.resetSideBar,
});

// Get the status of the sidebar from local storage
export const getSideBarStatus = () =>
	localStorage.getItem('sidebarPilu') === 'true';

// Set the status of the sidebar in local storage
export const setSideBarStatus = (value = undefined) => {
	if (value === undefined) {
		const status = getSideBarStatus();
		localStorage.setItem('sidebarPilu', status);
	} else {
		localStorage.setItem('sidebarPilu', value);
	}
};
